/* unplugin-vue-components disabled */import script from "./SubscModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscModal.vue?vue&type=script&setup=true&lang=ts"

import "./SubscModal.vue?vue&type=style&index=0&id=e78d17bc&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78d17bc"]])

export default __exports__